import { useState } from "react";
import { ToLocalFileAttachments } from "../../helpers/File";
import { LocalFileAttachment } from "../../types/LocalFileAttachment";
import { SharedBox } from "../../types/SharedBox";
import './AttachmentBox.scss';
import { ToHumanFileSize } from "../../helpers/SharedBox";
import { Button, Form } from "react-bootstrap";

export const FileBoxRow = ({
    file,
    onRemoveAttachment
}: {
    onRemoveAttachment?: any;
    file: LocalFileAttachment
}) => {
    return (
        <tr>
            <td>{file.name}</td>
            <td>{ToHumanFileSize(file.size)}</td>
            <td className="text-right">
                <Button
                    className="text-danger p-0"
                    variant="link"
                    onClick={() => {
                        onRemoveAttachment(file.id);
                    }}
                >Delete</Button>
            </td>
        </tr>
    );
}

export const AttachmentBox = ({
    sharedBox,
    attachments,
    setMessageAttachments,
}: {
    sharedBox: SharedBox;
    attachments: Array<LocalFileAttachment>;
    setMessageAttachments?: any;
}) => {
    const [dragActive, setDragActive] = useState(false);
    const handleAddAttachments = () => {
        const inputFile = document.createElement("input");
            inputFile.setAttribute("type", "file");
            inputFile.setAttribute("multiple", "multiple");
            inputFile.onchange = () => {
                if (!inputFile.files || !inputFile.files[0]) return;
                handleOnAddAttachments(inputFile.files);
                inputFile.remove();
            };
            inputFile.click();
    };
    const handleOnAddAttachments = (inputFiles: any) => {
        const files = ToLocalFileAttachments(inputFiles);
        setMessageAttachments((prev: any) => {
            const result = [...prev, ...files];
            return result;
        });
    };
    const handleAttachmentChange = (newAttachment: LocalFileAttachment) => {
        const idx = attachments.findIndex((elm) => elm.id === newAttachment.id);
        const newArr = [...attachments];
        newArr[idx] = {...newAttachment};
        setMessageAttachments(newArr);
    };
    const handleRemoveAttachment = (id: string) => {
        setMessageAttachments((prev: any) => {
            const newArr = (prev.filter((elm: any) => elm.id !== id))
            return newArr;
        });
    };
    const handleDrag = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = function(e: any) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleOnAddAttachments(e.dataTransfer.files);
        }
    };
    const files = 'border rounded border-dashed border-dark p-2 text-center text-muted c-pointer'.split('');
    return (
        <div className="d-flex flex-column">
            <Form.Label className="fw-semibold">Attachments</Form.Label>
            <div
                className="d-flex flex-column p-1 mb-3"
                onClick={handleAddAttachments}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
            >
                <div
                    className="border rounded border-dashed border-dark p-5 text-center text-muted c-pointer">
                    Click here or drag and drop files here to upload
                </div>
            </div>
            {attachments.length ?
                <div className="overflow-auto mb-2 d-flex flex-wrap" style={{ maxHeight: 110 }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>File Name</th>
                                <th style={{width: 120}}>Size</th>
                                <th style={{width: 120}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {attachments.map((file) => (
                                <FileBoxRow
                                    key={file.id}
                                    file={file}
                                    onRemoveAttachment={handleRemoveAttachment}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
                : null
            }
        </div>
    );
};

export default AttachmentBox;